import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "buttonText", "spinner"]
  static values = {
    subscriberId: Number
  }

  openModal(e) {
    e.preventDefault();
    
    // Show spinner and disable button
    this.buttonTarget.disabled = true;
    this.buttonTextTarget.style.display = 'none';
    this.spinnerTarget.style.display = 'inline-block';
    
    // Set the src of the modal turbo-frame and reload it
    const modalFrame = document.querySelector('turbo-frame#modal');
    modalFrame.src = `/admin/subscribers/${this.subscriberIdValue}/confirm_cancellation`;
    modalFrame.reload();
    
    // Re-enable button and hide spinner after a short delay
    // The modal will be visible by then
    setTimeout(() => {
      this.buttonTarget.disabled = false;
      this.buttonTextTarget.style.display = 'inline';
      this.spinnerTarget.style.display = 'none';
    }, 500);
  }
}
